import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_widget_indicator = _resolveComponent("widget-indicator")!

  return (_openBlock(), _createBlock(_component_widget_indicator, {
    title: _ctx.$t('indicators.run_time.label'),
    description: _ctx.$t('indicators.run_time.description'),
    value: _ctx.runtime
  }, null, 8 /* PROPS */, ["title", "description", "value"]))
}